import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M8 15c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm0-2c-2.761 0-5-2.239-5-5s2.239-5 5-5 5 2.239 5 5-2.239 5-5 5z"
        />
        <path
          className="icon-color"
          d="M8.984 7.392l1.302 1.322c.384.384 1.024.384 1.408 0 .384-.384.384-1.024 0-1.408L8.728 4.298C8.537 4.107 8.28 4 8.024 4c-.256 0-.511.107-.704.298L4.29 7.306c-.426.427-.383 1.152.13 1.515.404.298.98.213 1.322-.15l1.13-1.108.129-.022V11.018c0 .555.447.982.98.982.577 0 1.004-.448 1.004-.982V7.392z"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-2c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z"
        />
        <path
          className="icon-color"
          d="M15.287 11.692l-2.29-2.29v7.587c0 .55-.45 1-1 1-.551 0-1-.45-1-1V9.402l-2.291 2.29c-.39.39-1.025.39-1.414 0-.39-.389-.39-1.025 0-1.414l3.998-3.997c.058-.06.132-.092.2-.133.042-.025.076-.06.122-.08.04-.019.087-.019.13-.029.212-.057.436-.056.64.028.044.02.077.054.118.08.07.04.143.073.204.134l3.997 3.997c.389.39.389 1.025 0 1.414-.39.39-1.025.39-1.414 0z"
        />
      </g>
    </svg>
  ),
};
